import { render, staticRenderFns } from "./ProductInfoDefault.vue?vue&type=template&id=0178aae2&scoped=true"
import script from "./ProductInfoDefault.vue?vue&type=script&lang=ts"
export * from "./ProductInfoDefault.vue?vue&type=script&lang=ts"
import style0 from "./ProductInfoDefault.vue?vue&type=style&index=0&id=0178aae2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0178aae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0178aae2')) {
      api.createRecord('0178aae2', component.options)
    } else {
      api.reload('0178aae2', component.options)
    }
    module.hot.accept("./ProductInfoDefault.vue?vue&type=template&id=0178aae2&scoped=true", function () {
      api.rerender('0178aae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductInfoDefault.vue"
export default component.exports